import { statsData } from '@/mocks/data';

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-primary-500 to-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            数据见证实力
          </h2>
          <p className="text-background-50/80 max-w-xl mx-auto">
            太阳娱乐以卓越的品质和专业的服务赢得了广大用户的信赖与支持
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {statsData.map((stat, idx) => (
            <div
              key={idx}
              className="text-center p-6 rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-50/10"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-background-50/15 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-bold text-background-50 mb-1">{stat.value}</p>
              <p className="text-sm text-background-50/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}